import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import ReusableTable from '../../components/other/ReuseableTable'
import Loader from '../pages/loader'
import EditCreateCustomer from '../../components/Customers/EditCreateCustomer'
import CustomersChannels from '../../components/Customers/channels/CustomersChannels'
import CustomersServices from '../../components/Customers/services/CustomersServices'
import { toast } from 'react-toastify'
import { useGetCustomersQuery, useLazyGetCustomersQuery } from '../../redux/apis/customersManagement/customers/cMcustomerApiSlice'
import CountriesDropdown from '../../components/CountriesDropdown'
import SearchAndFilterBar from '../../components/other/search/SearchAndFilterBar'
import DownloadAllDataButton from '../../components/other/DownloadAllDataButton'
import { can } from '../../helpers/auth'

const CustomerInfo = React.memo(() => {
  const [search, setSearch] = useState('')
  const [filters, setFilters] = useState({})
  
  const context = useContext(AppSettings)
  
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 })
  const { data, isLoading, error, isFetching } = useGetCustomersQuery({
    expand: ['country', 'last_updated_by', 'media'].join(','),
    page: pagination.current,
    page_size: pagination.pageSize,
    ...(search ? { search } : {}),
    ...filters
  })

  const [holder, setHolder] = useState()
  const [edit, setEdit] = useState(false)
  const [create, setCreate] = useState(false)
  const [viewChannels, setViewChannels] = useState(false)
  const [viewServices, setViewServices] = useState(false)

  let columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', sorter: true },
    {
      title: 'CUSTOMER NAME',
      dataIndex: 'customer_name',
      key: 'customer_name',
      filter: true,
      filterType: 'text'
    },
    {
      title: 'CUSTOMER BUSINESS',
      dataIndex: 'customer_business',
      key: 'customer_business',
      filter: true,
      filterType: 'text'
    },
    {
      title: 'COUNTRY',
      dataIndex: 'country',
      key: 'country',
      filter: true,
      filterComponent: CountriesDropdown,
      render: country => (country ? country.country_name : '')
    },
    {
      title: 'CONTRACT START DATE',
      dataIndex: 'contract_start_date',
      key: 'contract_start_date',
      filter: true,
      filterType: 'date'
    },
    {
      title: 'CONTRACT END DATE',
      dataIndex: 'contract_end_date',
      key: 'contract_end_date',
      filter: true,
      filterType: 'date'
    },
    {
      title: 'LAST UPDATED BY',
      dataIndex: 'last_updated_by',
      key: 'last_updated_by',
      render: text => (
        <p>
          {text.first_name} {text.last_name}
        </p>
      )
    },
    {
      title: 'Actions',
      dataIndex: 'id',
      key: 'actions',
      render: (text, record) => (
        <div className='flex gap-2'>
          {can('put_customers') && (
            <button
              className='btn btn-outline-theme'
              onClick={() => handleEdit(record)}
            >
              Edit
            </button>
          )}
          {can('view_customerchannel') && (
            <button
              className='btn btn-warning'
              onClick={() => handleChannels(record)}
            >
              Channels
            </button>
          )}
          {can('get_customer_services') && (
            <button
              className='btn btn-primary'
              onClick={() => handleServices(record)}
            >
              Services
            </button>
          )}
        </div>
      )
    }
  ]

  const handleEdit = record => {
    setHolder(record)
    setEdit(true)
  }
  const handleChannels = record => {
    setHolder(record)
    setViewChannels(true)
  }
  const handleServices = record => {
    setHolder(record)
    setViewServices(true)
  }
  const handleTableChange = paginationInfo => {
    setPagination({
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize
    })
  }

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(msg => toast.error(msg))
    }
  }, [error])

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)
    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context])

  return (
    <div className='w-full flex flex-col'>
      <Loader isLoading={isLoading || isFetching} />

      {create && (
        <EditCreateCustomer
          state='create'
          open={create}
          setOpen={setCreate}
          record={null}
        />
      )}
      {edit && (
        <EditCreateCustomer
          state='edit'
          open={edit}
          setOpen={setEdit}
          record={holder}
        />
      )}
      {viewChannels && (
        <CustomersChannels
          open={viewChannels}
          setOpen={setViewChannels}
          record={holder}
        />
      )}
      {viewServices && (
        <CustomersServices
          open={viewServices}
          setOpen={setViewServices}
          record={holder}
        />
      )}
      <div className='flex '>
        <SearchAndFilterBar
          columns={columns}
          search={search}
          setSearch={setSearch}
          filters={filters}
          setFilters={setFilters}
          setPagination={setPagination}
        />

        <div className='ml-auto flex gap-4'>
          <DownloadAllDataButton
            lazyQueryHook={useLazyGetCustomersQuery}
            fileName='customers'
          />
          {can('post_customers') && (
            <button
              className='btn btn-outline-theme  mb-4'
              onClick={() => setCreate(true)}
            >
              Create Customer
            </button>
          )}
        </div>
      </div>

      <div className='row'>
        <ReusableTable
          columns={columns}
          data={data?.data?.results}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: data?.data?.count,
            showSizeChanger: true
          }}
          onChange={handleTableChange}
        />
      </div>
    </div>
  )
})

export default CustomerInfo
